import React, { Component } from 'react';
import { get } from 'lodash';
import Rules from './Rules';
import { Switch } from '@material-ui/core';
import { shape, func, bool, string, number, array, oneOfType } from 'prop-types';
import { getNextTime, getNextTimeStart, isCompareDate, isValidTime } from '../../helpers/formatData';

import styles from './styles.scss';
import { cloneDeep } from 'lodash';

const DATE_RANGES = 'date_ranges';

export default class AttributionTimespan extends Component {
  static propTypes = {
    appSetting: shape({
      ranges: array,
      default: oneOfType([string, number]),
      isOverride: bool
    }),
    title: string,
    description: string,
    toggleDescription: string,
    updateAppSetting: func,
  };

  static defaultProps = {
    title: 'Custom Attribution Timespan',
    description: 'Set the default attribution time and customize dayparts. The data will be recalculated if changed.',
    toggleDescription: 'Allow users to override the admin setting and set their own custom time.'
  };


  handleAddItem = () => {
    const { updateAppSetting, appSetting } = this.props;
    const { ranges, default: defaultValue } =  appSetting;

    const newListRules = cloneDeep(ranges);
    const startTime = get(
      newListRules,
      [newListRules.length - 1, 'end'],
      '01:00'
    );
    let startTimeNext = '01:00';
    if (startTime !== '01:00') {
      startTimeNext = getNextTimeStart(startTime);
    }
    const endTime = getNextTime(startTime);
    let lengthListValues = newListRules.length;
    newListRules.push({
      start: startTimeNext,
      end: endTime,
      check: true,
      checkCompare: true,
      value: lengthListValues
        ? newListRules[lengthListValues - 1].value
        : defaultValue
    });

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        ranges: newListRules,
      }
    });

  };

  handleChangeStartTime = (value, index) => {
    const { updateAppSetting, appSetting } = this.props;
    const newListRules = cloneDeep(appSetting.ranges);

    newListRules[index].start = value;
    newListRules[index].check = isValidTime(index, newListRules);
    newListRules.forEach((rule, idx) => {
      rule.checkCompare = isCompareDate(rule);
      if (isValidTime(idx, newListRules)) {
        newListRules[idx].check = true;
      }
    });

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        ranges: newListRules,
      }
    });

  };

  handleChangeEndTime = (value, index) => {
    const { updateAppSetting, appSetting } = this.props;
    const newListRules = cloneDeep(appSetting.ranges);

    newListRules[index].end = value;
    newListRules[index].check = isValidTime(index, newListRules);
    newListRules.forEach((rule, idx) => {
      rule.checkCompare = isCompareDate(rule);
      if (isValidTime(idx, newListRules)) {
        newListRules[idx].check = true;
      }
    });

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        ranges: newListRules,
      }
    });
  };

  handleRemoveItem = index => {
    const { updateAppSetting, appSetting } = this.props;
    const newListRules = cloneDeep(appSetting.ranges);

    newListRules.splice(index, 1);
    newListRules.forEach((rule, idx) => {
      rule.checkCompare = isCompareDate(rule);
      if (isValidTime(idx, newListRules)) {
        newListRules[idx].check = true;
      }
    });

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        ranges: newListRules,
      }
    });
  };

  handleChangeOverride = event => {
    const { updateAppSetting } = this.props;
    const name = event.target.name;

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        [name]: event.target.checked
      }
    });
  };

  handleChangeValue = (value, index) => {
    const { updateAppSetting, appSetting } = this.props;
    const newListRules = cloneDeep(appSetting.ranges);

    let parsedValue = parseInt(value || '1');
    parsedValue = Math.max(1, Math.min(60, value));
    newListRules[index].value = parsedValue;
    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        ranges: newListRules,
      }
    });
  };

  handleChangeDefaultValue = defaultValue => {
    const { updateAppSetting } = this.props;

    updateAppSetting && updateAppSetting({
      setting_name: DATE_RANGES,
      setting_value: {
        default: defaultValue
      }
    });
  };

  render() {
    const { title, description, toggleDescription, appSetting = {} } = this.props;
    const {ranges,  default: defaultValue, isOverride } = appSetting;
    return (
      <div className={styles.container}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.switchBox}>
          <Switch
            checked={isOverride}
            onChange={this.handleChangeOverride}
            name="isOverride"
            color="primary"
          />
          <span className={styles.switchDescription}>{toggleDescription}</span>
        </div>

        <Rules
          appConfigRules
          listRules={ranges}
          onAddItem={this.handleAddItem}
          onChangeEndTime={this.handleChangeEndTime}
          onChangeStartTime={this.handleChangeStartTime}
          onRemoveItem={this.handleRemoveItem}
          onChangeValue={this.handleChangeValue}
          onChangeDefaultValue={this.handleChangeDefaultValue}
          defaultValue={defaultValue}
        />
      </div>
    );
  }
}